import { storageProxy } from './cache'
import { CacheKeys } from '@/enums/cacheEnum'
import { PhysicalWarehouseListItem, RegionWarehouseListItem } from '@/api/common/model'

export const setToken = (token: string) => {
  return storageProxy.set(CacheKeys.TOKEN, token)
}

export const getToken = () => {
  return storageProxy.get(CacheKeys.TOKEN) as string
}

export const clearToken = () => {
  return storageProxy.remove(CacheKeys.TOKEN)
}

export const getWarehouseCode = () => {
  return storageProxy.get('warehouse_code')
}

export const getUserPhysicalWarehouseList = () => {
  return storageProxy.get(CacheKeys.USER_PHYSICAL_WAREHOUSE_LIST) as PhysicalWarehouseListItem[]
}

export const setUserPhysicalWarehouseList = (
  physicalWarehouseList: PhysicalWarehouseListItem[],
) => {
  return storageProxy.set(CacheKeys.USER_PHYSICAL_WAREHOUSE_LIST, physicalWarehouseList)
}

export const getAllPhysicalWarehouseList = () => {
  return storageProxy.get(CacheKeys.ALL_PHYSICAL_WAREHOUSE_LIST) as PhysicalWarehouseListItem[]
}

// 缓存当前区域仓下所有物理仓信息
export const setAllPhysicalWarehouseList = (physicalWarehouseList: PhysicalWarehouseListItem[]) => {
  return storageProxy.set(CacheKeys.ALL_PHYSICAL_WAREHOUSE_LIST, physicalWarehouseList)
}

export const getAllRegionWarehouseList = () => {
  return storageProxy.get(CacheKeys.ALL_WAREHOUSE_LIST) as RegionWarehouseListItem[]
}

/**
 * 缓存所有区域仓信息
 * @param regionWarehouseList
 * @returns
 */
export const setAllRegionWarehouseList = (regionWarehouseList: RegionWarehouseListItem[]) => {
  return storageProxy.set(CacheKeys.ALL_WAREHOUSE_LIST, regionWarehouseList)
}

export const clearUserPhysicalWarehouseList = () => {
  return storageProxy.remove(CacheKeys.USER_PHYSICAL_WAREHOUSE_LIST)
}

export const clearAllPhysicalWarehouseList = () => {
  return storageProxy.remove(CacheKeys.ALL_PHYSICAL_WAREHOUSE_LIST)
}

export const clearALLRegionWarehouseStorage = () => {
  return storageProxy.remove(CacheKeys.ALL_WAREHOUSE_LIST)
}

export default {
  set: setToken,
  get: getToken,
  clear: clearToken,
}
